import axios from "axios"

export default class Http {
    queen = {}
    constructor (baseUrl) {
        this.baseUrl = baseUrl
    }

    interceptors (instance, url) {
      instance.interceptors.request.use(config => {
          this.queen[url] = true
          return config
      }, err => Promise.reject(err))

      instance.interceptors.response.use(response => {
        if (response.status === 200) {
          return response.data
        }
      }, error => {
        //   let errorInfo = error.response
        //   if (!errorInfo) {
        //     const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
        //     errorInfo = { statusText, status, request: { responseURL: config.url } }
        //   }
          alert(error?.response?.data?.message || error?.response?.data?.error || error.message)
          return Promise.reject(error)
      })
    }

    request (options) {
      const instance = axios.create()
      const config = Object.assign({
        baseURL: this.baseUrl,
        // timeout: 10000,
        timeoutErrorMessage: '服务响应超时',
        headers: {
          'Content-Type': '	application/json',
        }
      }, options)
      this.interceptors(instance, options.url)
      return instance(config)
    }
}
